<script>
    import Button from "@smui/button";

    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Address from "../../components/Address.svelte";
    import title from "../../components/title";
    import { getObject, setObject } from "../../session";

    export let location;
    let isLoading = false;

    let name = "";
    let phone = "";

    let province, city, district;
    let address = "";
    let code = "";

    function next() {
        const pickup = getObject("pickup");
        pickup["pickup_name"] = name;
        pickup["pickup_phone"] = phone;
        pickup["pickup_address"] = address;
        pickup["pickup_city"] = city;
        pickup["pickup_province"] = province;
        pickup["pickup_district"] = district;
        pickup["pickup_zipcode"] = "-";
        pickup["origin_code"] = code;

        setObject("pickup", pickup);
        navigate("/pickup/orders");
    }

    onMount(() => {
        title.set("Alamat Pickup Baru");
    });
</script>

<div class="content">
    <Textfield
        bind:value={name}
        variant="outlined"
        label="Nama"
        disabled={isLoading} />
    <Textfield
        bind:value={phone}
        variant="outlined"
        label="Telepon"
        disabled={isLoading} />
    <Address
        mode="origin"
        bind:province
        bind:city
        bind:district
        bind:address
        bind:code
        bind:disabled={isLoading} />
    {#if district != ''}
        <div class="text-right">
            <Button on:click={next} variant="outlined" class="rounded">
                OK
            </Button>
        </div>
    {/if}
</div>
